/* document.getElementById("js-cookies--btn") */
document
  .getElementsByClassName('js-cookies--btn')[0]
  .addEventListener('click', function(event) {
    event.preventDefault();
    document.getElementsByClassName('cli_settings_button')[0].click();
  });

document
  .getElementsByClassName('cli-privacy-readmore')[0]
  .addEventListener('click', function() {
    setTimeout(function() {
      const el = document
        .getElementsByClassName('cli-privacy-content-text')[0]
        .querySelectorAll('div > a')[0];

      if (el) {
        el.nextSibling.nodeValue = '';
        el.remove();
      }
    }, 10);
  });
